import classNames from 'classnames';

import styles from './MainSectionWrapper.module.css';

export const MainSectionWrapper = ({
    className,
    innerWrapperClassName,
    children
}: {
    className?: string;
    innerWrapperClassName?: string;
    children: React.ReactNode;
}) => {
    return (
        <div
            className={classNames(styles.MainSectionWrapper, className)}
            data-testid="wrapper"
        >
            <div
                data-testid="wrapperInner"
                className={classNames(
                    styles.wrapperInner,
                    innerWrapperClassName
                )}
            >
                {children}
            </div>
        </div>
    );
};
